<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 417 417"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <path
      d="M208.333,4.215c112.656,-0 204.119,91.462 204.119,204.118c-0,112.656 -91.463,204.119 -204.119,204.119c-112.656,-0 -204.118,-91.463 -204.118,-204.119c-0,-112.656 91.462,-204.118 204.118,-204.118Zm21.811,269.131l-43.622,0l0,41.624l43.622,0l0,-41.624Zm0,-171.649l-43.622,-0l0,143.307l43.622,0l0,-143.307Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAlert"
};
</script>
